var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useRef, useEffect, useState } from "react";
import { Avatar, Box, Button, Card, Grid, Typography } from "@mui/material";
import { CameraAlt } from "@mui/icons-material";
export var WebcamCapture = function (_a) {
    var onCapture = _a.onCapture;
    var videoRef = useRef(null);
    var canvasRef = useRef(null);
    var _b = useState(null), capturedImage = _b[0], setCapturedImage = _b[1]; // Novo estado para armazenar a imagem capturada
    var _c = useState(null), videoStream = _c[0], setVideoStream = _c[1];
    useEffect(function () {
        var requestCameraAccess = function () { return __awaiter(void 0, void 0, void 0, function () {
            var stream, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, navigator.mediaDevices.getUserMedia({
                                video: true,
                            })];
                    case 1:
                        stream = _a.sent();
                        setVideoStream(stream);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        console.error("Erro ao acessar a câmera:", err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        requestCameraAccess();
    }, [videoStream]);
    useEffect(function () {
        var currentVideoElement = videoRef.current;
        var startCamera = function () { return __awaiter(void 0, void 0, void 0, function () {
            var stream, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                            alert("Seu navegador não suporta acesso à câmera.");
                            console.error("API getUserMedia não disponível.");
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, navigator.mediaDevices.getUserMedia({
                                video: true,
                            })];
                    case 2:
                        stream = _a.sent();
                        console.log("Stream obtido:", stream);
                        if (!(currentVideoElement && stream)) return [3 /*break*/, 4];
                        if (!!currentVideoElement.srcObject) return [3 /*break*/, 4];
                        currentVideoElement.srcObject = stream;
                        console.log("Stream vinculado ao vídeo");
                        return [4 /*yield*/, currentVideoElement.play()];
                    case 3:
                        _a.sent(); // Aguarde a execução para lidar com erros
                        console.log("Stream play");
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        console.error("Erro ao acessar a câmera:", error_1);
                        alert("Erro ao acessar a câmera. Verifique as permissões.");
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        startCamera();
        return function () {
            if (currentVideoElement && currentVideoElement.srcObject) {
                var tracks = currentVideoElement.srcObject.getTracks();
                tracks.forEach(function (track) { return track.stop(); });
                currentVideoElement.srcObject = null; // Remova a referência ao stream
            }
        };
    }, [videoRef]);
    // useEffect(() => {
    //   console.log("mudou ref");
    //   let currentVideoElement = videoRef.current;
    //
    //   const startCamera = async () => {
    //     if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    //       alert("Seu navegador não suporta acesso à câmera.");
    //       console.error("API getUserMedia não disponível.");
    //       return;
    //     }
    //
    //     try {
    //       const stream = await navigator.mediaDevices.getUserMedia({
    //         video: true,
    //       });
    //       console.log("Stream obtido:", stream);
    //
    //       if (videoRef.current) {
    //         videoRef.current.srcObject = stream;
    //         console.log("Stream vinculado ao vídeo");
    //         videoRef.current.play();
    //         console.log("Stream play");
    //         // setIsCameraActive(true);
    //       }
    //     } catch (error) {
    //       console.error("Erro ao acessar a câmera:", error);
    //       alert("Erro ao acessar a câmera. Verifique as permissões.");
    //     }
    //   };
    //
    //   startCamera();
    //
    //   return () => {
    //     if (currentVideoElement && currentVideoElement?.srcObject) {
    //       const tracks = (
    //         currentVideoElement?.srcObject as MediaStream
    //       ).getTracks();
    //       tracks.forEach((track) => track.stop());
    //     }
    //   };
    // }, [videoRef]);
    var captureImage = function () {
        if (videoRef.current && canvasRef.current) {
            var context = canvasRef.current.getContext("2d");
            if (context) {
                canvasRef.current.width = videoRef.current.videoWidth;
                canvasRef.current.height = videoRef.current.videoHeight;
                context.drawImage(videoRef.current, 0, 0, canvasRef.current.width, canvasRef.current.height);
                var imageBase64 = canvasRef.current.toDataURL("image/png");
                onCapture === null || onCapture === void 0 ? void 0 : onCapture(imageBase64);
                setCapturedImage(imageBase64);
                console.log(imageBase64);
            }
        }
    };
    var StepIcon = function (_a) {
        var stepNumber = _a.stepNumber;
        return (_jsx(Avatar, __assign({ sx: {
                backgroundColor: "#1976d2",
                width: 40,
                height: 40,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            } }, { children: _jsx(Typography, __assign({ variant: "h6", sx: { color: "white" } }, { children: stepNumber })) })));
    };
    return (_jsx(Box, { children: _jsx(Card, __assign({ sx: {
                py: 2,
                px: 6,
            } }, { children: _jsxs(Grid, __assign({ container: true }, { children: [_jsxs(Box, __assign({ display: "flex", alignItems: "center", mb: 2 }, { children: [_jsx(StepIcon, { stepNumber: 2 }), _jsx(Typography, __assign({ ml: 2, variant: "h6" }, { children: "Capture uma nova imagem" }))] })), _jsx(Box, __assign({ sx: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 2,
                            border: "2px solid #ccc",
                            borderRadius: "8px",
                            padding: "16px",
                            maxWidth: "500px",
                        } }, { children: !capturedImage ? (_jsxs(_Fragment, { children: [_jsx("video", __assign({ ref: videoRef, style: {
                                        width: "100%",
                                        borderRadius: "8px",
                                    }, autoPlay: true, playsInline: true }, { children: _jsx("track", { kind: "captions", label: "Webcam" }) })), _jsx("canvas", { ref: canvasRef, style: { display: "none" } }), _jsx(Button, __assign({ variant: "contained", color: "primary", startIcon: _jsx(CameraAlt, {}), onClick: captureImage }, { children: "Capturar Imagem" }))] })) : (_jsxs(_Fragment, { children: [_jsx("img", { src: capturedImage || "", alt: "Imagem Capturada", style: {
                                        maxWidth: "100%",
                                        height: "auto",
                                        borderRadius: "8px",
                                        marginTop: "16px",
                                    } }), _jsx("br", {})] })) }))] })) })) }));
};
